<template>
  <div style="width: 100%; background: #ffffff;">
    <div v-if="!hasH5" class="detail-main">
      <site-header />
      <div v-if="false" class="header">
        <div class="header-left" style="cursor: pointer">
          <img @click="toPath('/index')" data-track-text="首页Logo" aria-label="首页Logo" src="../assets/img/logo-big.png"  height="50">
        </div>
        <div class="header-right" style="cursor: pointer">
          <div style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;margin-right: 10px">
            <span v-if="groupUserInfo==='机构登录'" data-track-text="机构登录" aria-label="机构登录" @click="showIframe('/login')">{{ groupUserInfo }}</span>
            <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                         style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #ffffff">
              <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'" class="title_hide">{{ groupUserInfo }}</span>
              <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
                <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                                  style="z-index: 1;font-weight: 800">
                <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                    item.name
                  }}</span>
                  <span
                      style="margin-left:10px; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                      v-if="!item.isIpScore">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
            <el-dropdown @command="logOut" v-if="showloginOut"
                         style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #ffffff;display: flex;
    align-items: center;
    justify-content: center;">
            <span v-show="userInfo!==''" class="title_hide">
              {{ userInfo }}
            </span>
              <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人中心</span>
                </el-dropdown-item>
                <el-dropdown-item style="z-index: 1;font-weight: 800">
                  <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span data-track-text="个人中心" aria-label="个人中心" @click="toCenter">
            <img v-if="userType==='0'" class="user-img" src="../assets/img/person_no.png" alt="">
            <img v-if="userType==='1'" class="user-img" src="../assets/img/child_no.png" alt="">
            <img v-if="userType==='2'" class="user-img" src="../assets/img/roaming_no.png" alt="">
          </span>
          </div>
          <div v-show="userInfo===''" data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</div>
          <div v-show="userInfo===''" data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</div>
          <div>｜</div>
          <div v-if="isShowInRoaming&&showRoaming">
            <el-popover
                @hide="removeQrcode"
                @show="getQrcode"
                placement="top-start"
                title="扫一扫开通漫游"
                width="150"
                trigger="hover">
              <el-image
                  :src="qrcodeUrl"
                  fit="contain"
                  style="width: 150px; height: 150px"
                  alt="开通漫游">
              </el-image>
              <el-button type="text" slot="reference">开通漫游</el-button>
            </el-popover>
            <div style="margin-top: -28px;margin-left: -25px;"><img src="../assets/new_icon.png" alt=""></div>
          </div>
          <div data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">
            帮助
          </div>
        </div>
      </div>
      <div v-if="false" class="header-hr"/>
      <div class="detail-main-head">
        <span data-track-text="详情页返回首页" aria-label="详情页返回首页" @click="toPath('/')">首页</span> > <span data-track-text="详情页返回文档历史" aria-label="详情页返回文档历史" @click="toPath('/list')">文档历史</span> > <span
          style="color: rgba(138, 137, 137, 1)">详情</span>
      </div>
      <div class="detail-main-tip" v-if="(status!=='501'&&status!=='448')">
        <div class="detail-main-title">
          <div>
            文件名：<span
              style="
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: rgba(51, 51, 51, 1);width: 590px;white-space: normal;overflow-x: hidden;text-overflow: ellipsis;display: inline-flex;">{{
              title
            }}</span>
          </div>
          <div v-show="timeCost&&!overDate">预计完成时间：{{ timeCost }}前</div>
        </div>
        <div class="detail-main-info" v-show="!overDate">注：在未支付前，预计完成时间不显示</div>
      </div>
      <div class="detail-main-step" v-if="(status!=='501'&&status!=='448')">
        <div>
          <img src="../assets/img/ok.png" alt=""/>
        </div>
        <div :class="orderDate?'detail-main-step-item':'detail-main-step-item-no'"></div>
        <div>
          <img v-show="orderDate&&processDate" src="../assets/img/ok.png" alt=""/>
          <img v-show="orderDate&&!processDate" src="../assets/img/process.png" alt=""/>
          <img v-show="!orderDate" src="../assets/img/no.png" alt=""/>
        </div>
        <div :class="processDate?'detail-main-step-item':'detail-main-step-item-no'"></div>
        <div>
          <img v-show="processDate&&payDate" src="../assets/img/ok.png" alt=""/>
          <img v-show="processDate&&!payDate" src="../assets/img/process.png" alt=""/>
          <img v-show="!processDate" src="../assets/img/no.png" alt=""/>
        </div>
        <div :class="payDate?'detail-main-step-item':'detail-main-step-item-no'"></div>
        <div>
          <img v-show="payDate&&transDate" src="../assets/img/ok.png" alt=""/>
          <img v-show="payDate&&!transDate" src="../assets/img/process.png" alt=""/>
          <img v-show="!payDate" src="../assets/img/no.png" alt=""/>
        </div>
        <div :class="transDate?'detail-main-step-item':'detail-main-step-item-no'"></div>
        <div>
          <img v-show="transDate&&overDate" src="../assets/img/ok.png" alt=""/>
          <img v-show="transDate&&!overDate" src="../assets/img/process.png" alt=""/>
          <img v-show="!transDate" src="../assets/img/no.png" alt=""/>
        </div>
      </div>
      <div class="detail-main-step" v-if="(status!=='501'&&status!=='448')" style="width: 1010px;
    display: flex;
    justify-content: space-between;margin-bottom: 95px">
        <div>
          <div style="margin-top: 12px">提交订单</div>
          <div style="    width: 67px;text-align: center; font-size: 12px;margin-top: 8px">{{ orderDate || "-" }}</div>
        </div>
        <div style="margin-left: 12px">
          <div style="margin-top: 12px;">等待客服沟通报价</div>
          <div style=" width: 67px;text-align: center;font-size: 12px;margin-top: 8px">{{ processDate || "-" }}</div>
        </div>
        <div style="margin-right: 10px;">
          <div style="margin-top: 12px;    ">确认并支付订单</div>
          <div style="width: 67px;text-align: center; font-size: 12px;margin-top: 8px">{{ payDate || "-" }}</div>
        </div>
        <div style=" margin-right: 33px;">
          <div style="margin-top: 12px;   ">翻译中</div>
          <div style="width: 67px;text-align: center; font-size: 12px;margin-top: 8px">{{ transDate || "-" }}</div>
        </div>
        <div>
          <div style="margin-top: 12px">翻译完成</div>
          <div style="width: 67px;text-align: center; font-size: 12px;margin-top: 8px">{{ overDate || "-" }}</div>
        </div>
      </div>
      <div class="detail-main-step" v-if="(status==='501'||status==='448')" style="margin: 150px 0;">
        <div v-if="status==='501'"
             style="font-size: 22px;font-family: Adobe Heiti Std;font-weight: normal;color: #E13F3F;flex-flow: row"><img
            src="../assets/img/over.png" width="50" alt="" style="margin-right: 20px">文档已删除
        </div>
        <div v-if="status==='448'"
             style="font-size: 22px;font-family: Adobe Heiti Std;font-weight: normal;color: #E13F3F;flex-flow: row"><img
            src="../assets/img/over.png" width="50" alt="" style="margin-right: 20px">任务已终止
        </div>
      </div>
      <div class="detail-main-rx">
        <div></div>
        <div>客服热线</div>
      </div>
      <div class="detail-main-rx-desc">
        <div>支付问题请联系：010-80755328（工作日：周一至周五早9点至晚六点）或联系 <span data-track-text="详情页在线QQ咨询" aria-label="详情页在线QQ咨询" @click="toQQ"
                                                             style="cursor:pointer;color: var(--primary)">在线QQ</span>
        </div>
        <div>翻译问题请联系：400-004-5131</div>
      </div>
      <div v-if="false" class="foot">
        <span>© 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All rights reserved. 京公网安备</span>
        <span><a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">联系邮箱：info@wiseivy.com.cn</a>
        <span style="margin-left: 15px">联系电话：010-80755328</span></span>
      </div>
      <site-footer />
    </div>
    <div v-if="hasH5" class="step-main">
      <div class="step-main-head">
        <div class="step-main-head-content" data-track-text="H5详情返回列表" aria-label="H5详情返回列表" @click="()=>this.$router.push('/list')">
          <div><</div>
          <div>返回</div>
        </div>
      </div>
      <div v-if="(status!=='501'&&status!=='448')" class="step-main-content">
        <div class="step-main-content-title">{{ title }}</div>
        <div v-if="timeCost&&!overDate" class="step-main-content-time-cost">预计完成时间：{{ timeCost }}前</div>
        <div class="step-main-content-step">
          <div class="step-main-content-step-item">
            <div class="step-main-content-step-item-one">
              <img src="../assets/img/ok.png" alt=""/>
            </div>
            <div class="step-main-content-step-item-two">
              <div>订单提交</div>
              <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ orderDate || '-' }}</div>
            </div>
          </div>
          <div :class="orderDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
          <div class="step-main-content-step-item">
            <div class="step-main-content-step-item-one">
              <img v-show="orderDate&&processDate" src="../assets/img/ok.png" alt=""/>
              <img v-show="orderDate&&!processDate" src="../assets/img/process.png" alt=""/>
              <img v-show="!orderDate" src="../assets/img/no.png" alt=""/>
            </div>
            <div class="step-main-content-step-item-two">
              <div>等待客服沟通报价</div>
              <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ processDate || '-' }}</div>
            </div>
          </div>
          <div :class="processDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
          <div class="step-main-content-step-item">
            <div class="step-main-content-step-item-one">
              <img v-show="processDate&&payDate" src="../assets/img/ok.png" alt=""/>
              <img v-show="processDate&&!payDate" src="../assets/img/process.png" alt=""/>
              <img v-show="!processDate" src="../assets/img/no.png" alt=""/>
            </div>
            <div class="step-main-content-step-item-two">
              <div>确认并支付订单</div>
              <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ payDate || '-' }}</div>
            </div>
          </div>
          <div :class="payDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
          <div class="step-main-content-step-item">
            <div class="step-main-content-step-item-one">
              <img v-show="payDate&&transDate" src="../assets/img/ok.png" alt=""/>
              <img v-show="payDate&&!transDate" src="../assets/img/process.png" alt=""/>
              <img v-show="!payDate" src="../assets/img/no.png" alt=""/>
            </div>
            <div class="step-main-content-step-item-two">
              <div>翻译中</div>
              <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ transDate || '-' }}</div>
            </div>
          </div>
          <div :class="transDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
          <div class="step-main-content-step-item">
            <div class="step-main-content-step-item-one">
              <img v-show="transDate&&overDate" src="../assets/img/ok.png" alt=""/>
              <img v-show="transDate&&!overDate" src="../assets/img/process.png" alt=""/>
              <img v-show="!transDate" src="../assets/img/no.png" alt=""/>
            </div>
            <div class="step-main-content-step-item-two">
              <div>翻译完成</div>
              <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ overDate || '-' }}</div>
            </div>
          </div>
          <div class="step-main-content-foot">
            <div class="step-main-content-foot-title">
              <div></div>
              <div>客服热线</div>
            </div>
            <div class="step-main-content-foot-desc">
              支付问题请联系：010-80755328<br/>
              （工作日：周一至周五早9点至晚六点）或联系
              <span style="color: var(--primary)" data-track-text="H5详情在线QQ咨询" aria-label="H5详情在线QQ咨询" @click="toQQ">在线QQ</span>
            </div>
            <div class="step-main-content-foot-desc" style="margin-top: 27px">
              翻译问题请联系：400-004-5131
            </div>
          </div>
        </div>
      </div>
      <div v-if="(status==='501'||status==='448')" class="step-main-content">
        <div v-if="status==='501'"
             style="    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #E13F3F;flex-flow: row"><img
            src="../assets/img/over.png" width="50" alt="" style="margin-right: 20px">文档已删除
        </div>
        <div v-if="status==='448'"
             style="    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #E13F3F;flex-flow: row"><img
            src="../assets/img/over.png" width="50" alt="" style="margin-right: 20px">任务已终止
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {authServiceClient, translateServiceClient} from "@/tools/api/service";
import {outRequest, thirdLoginRequest, userPowerRequest, userStatusRequest} from "@/tools/api/auth-api";
import {Base64} from "js-base64";
import {checkRoamingRequest, uploadTipRequest, detailRequest} from "@/tools/api/translate-api";
import SiteHeader from "@/components/home/SiteHeader.vue";
import SiteFooter from "@/components/home/SiteFooter.vue";

export default {
  name: "Detail",
  components: { SiteHeader, SiteFooter },
  data() {
    return {
      showSelect: false,
      hasH5: false,
      hasAwarded: true,
      payCenterDialogVisible2: false,
      payCenterDialogVisible: false,
      qrcodeUrl: '',
      groupUserInfos: [],
      userInfo: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      showRoaming: false,
      groupUserInfo: '',
      userId: '',
      userType: '',
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      isShowInRoaming: false,
      isShowTransPro: false,
      timer: undefined,
      title: '',
      status: '',
      timeCost: '',
      orderDate: '',
      processDate: '',
      payDate: '',
      transDate: '',
      overDate: '',
    }
  },
  watch: {
    payCenterDialogVisible(val) {
      if (val) {
        this.timer = setTimeout(this.payCenterDialogVisibleClose, 5000);
      }
    },
  },
  created() {
    this.getDetail();
    this.showTip()
    this.getUploadTip()
    const that = this;
    window.addEventListener('message', function (e) {
      if (e.data.data === "params") {
        if (that.hasH5) {
          that.$router.push('/h5/login')
          return
        }
        that.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      }
      if (e.data.data === "register") {
        that.openTry()
      }
      if (e.data.data === "close") {
        layer.closeAll()
      }
      if (e.data.data === "topHidden") {
        that.showHeader = false
      }
      if (e.data.data === "topNotHidden") {
        that.showHeader = true
      }
    })
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.groupUserInfo = "";
        this.showRoaming = false;
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          if (item.type === 'Person') {
            this.userType = '0'
          }
          if (item.type === 'Child') {
            this.userType = '1'
          }
          this.userInfo = realName
          this.userId = item.name;
          if (!item.isRoaming) {
            let roaming = localStorage.getItem(this.userId)
            if (!roaming || roaming !== '1') {
              this.showRoaming = true
            } else {
              this.showRoaming = false
              this.userType = '2'
            }
          } else {
            this.userType = '2'
          }
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "";
      this.showRoaming = false
    });
  },
  mounted() {
  
    this.handleDetailViewportChange()
    window.addEventListener('resize', this.handleDetailViewportChange)
    const code = this.getUrlParameter(this.$route.fullPath).code;
    const state = this.getUrlParameter(this.$route.fullPath).state;
    if (code !== undefined && code !== null && code !== "") {
      this.checkLogin(code, state);
      return
    }
  },
  methods: {
    handleDetailViewportChange() {
      this.hasH5 = this.isMobile()
    },
    getDetail: function () {
      let documentId = this.$route.params.documentId;
      if (!documentId) {
        this.$router.push('/list')
      }
      let request = detailRequest
      request.setDocId(documentId)
      const TOKEN_KEY = 'token';
      translateServiceClient.getDetail(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let title = res.getTitle();
        if (!title) {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: "当前文档暂时不支持查看详情"
          });
          this.$router.push('/list')
          return
        }
        this.title = title
        this.status = res.getStatus();
        this.timeCost = res.getTimeCost();
        this.orderDate = res.getOrderDate();
        this.processDate = res.getProcessDate();
        this.payDate = res.getPayDate();
        this.transDate = res.getTransDate();
        this.overDate = res.getOverDate();
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "当前文档暂时不支持查看详情"
        });
        this.$router.push('/list')
      })
    },
    toQQ() {
      document.location.href = 'http://wpa.qq.com/msgrd?v=3&uin=1077258421&site=qq&menu=yes'
    },
    //是移动端返回true,否则false
    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches
    },
    payCenterDialogVisible2Close() {
      this.payCenterDialogVisible2 = false
      localStorage.setItem("payCenterDialogVisible2", false)
    },
    payCenterDialogVisibleClose() {
      this.payCenterDialogVisible = false
      localStorage.setItem("payCenterDialogVisible", false)
      let payCenterDialogVisible2 = localStorage.getItem("payCenterDialogVisible2")
      this.payCenterDialogVisible2 = !(payCenterDialogVisible2 !== undefined && payCenterDialogVisible2 !== null);
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowInRoaming = res.getIsRoaming();
        this.isShowTransPro = res.getIsTransPro();
      }).catch(err => {
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
      });
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode"
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== '1') {
        let request = checkRoamingRequest
        request.setUserId(this.userId)
        const TOKEN_KEY = "token";
        translateServiceClient.checkRoaming(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          localStorage.setItem(this.userId, res.getMessage())
          if (res.getMessage() === '1') {
            window.location.reload()
          }
        }).catch(err => {
        })
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    showTip() {
      let hasAwarded = localStorage.getItem("hasAwarded")
      if (hasAwarded !== undefined && hasAwarded !== null) {
        this.hasAwarded = false;
      }
      let payCenterDialogVisible = localStorage.getItem("payCenterDialogVisible")
      let payCenterDialogVisible2 = localStorage.getItem("payCenterDialogVisible2")
      this.payCenterDialogVisible = !(payCenterDialogVisible !== undefined && payCenterDialogVisible !== null);
      if (!this.payCenterDialogVisible) {
        this.payCenterDialogVisible2 = !(payCenterDialogVisible2 !== undefined && payCenterDialogVisible2 !== null);
      }
    },
    checkLogin(code, state) {
      let request = thirdLoginRequest;
      request.setCode(code)
      request.setState(state)
      const TOKEN_KEY = 'token';
      authServiceClient.thirdLogin(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let status = res.getStatus();
        if (status === "400") {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          setTimeout(this.toNew, 3000);
          return;
        }
        if (status === "201") {
          let openid = res.getOpenid();
          let type = res.getType();
          if (this.hasH5) {
            this.$router.push({
              name: "NewBind",
              params: {openid: openid, type: type}
            })
            return;
          }
          this.$router.push({
            name: "Bind",
            params: {openid: openid, type: type}
          })
          return;
        }
        if (status === "200") {
          this.$router.push("/index")
          window.location.reload()
          return;
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "登录失败请重试"
        });
      })
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    toLogin() {
      const TOKEN_KEY = 'token';
      authServiceClient.getUserStatus(userStatusRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (!res.getStatus()) {
          localStorage.removeItem("token")
          localStorage.removeItem("auth-context")
          window.parent.postMessage({
            data: "register"
          }, '*');
          return;
        }
        if (localStorage.getItem('auth-context') &&
            localStorage.getItem('token')) {
          authServiceClient.checkUserPower(userPowerRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (res.getStatus()) {
              this.$router.push('/translate')
              return;
            }
            this.$message({
              center: true,
              type: 'error',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            });
            window.parent.postMessage({
              data: "params"
            }, '*');
          }).catch(err => {
            window.parent.postMessage({
              data: "params"
            }, '*');
          })
        }
      }).catch(err => {
        window.parent.postMessage({
          data: "register"
        }, '*');
      });
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    closeAwarded() {
      this.hasAwarded = false
      localStorage.setItem("hasAwarded", false)
    },
    toPath(url) {
      this.showSelect = false
      if (url === '/trans-pro') {
        window.open("/trans-pro/index", "_self")
        return;
      }
      if (url === '/list' || url === '/list-pro') {
        const TOKEN_KEY = 'token';
        authServiceClient.getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (!res.getStatus()) {
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            if (this.hasH5) {
              this.$router.push('/h5/login')
              return
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            return;
          }
          if (localStorage.getItem('auth-context') &&
              localStorage.getItem('token')) {
            authServiceClient.checkUserPower(userPowerRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }).then(res => {
              if (res.getStatus()) {
                this.$router.push(url)
                return;
              }
              this.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              if (this.hasH5) {
                this.$router.push("/h5/login")
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            }).catch(err => {
              if (this.hasH5) {
                this.$router.push("/h5/login")
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            })
          }
        }).catch(err => {
          if (this.hasH5) {
            this.$router.push("/h5/login")
            return;
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        });
        return
      }
      this.$router.push(url);
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    openTry() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      }
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", '_blank')
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", '_blank')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.showRoaming = false
        if (this.hasH5) {
          this.$router.push('/h5/login')
          return
        }
        this.$router.push("/index")
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      });
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.handleDetailViewportChange)
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style lang="less" scoped>
.detail-main {
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  background: #ffffff;

  .header {
    display: flex;
    width: 1200px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 80px;

    .header-left {
      display: flex;
      width: 135px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .header-right {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      .title_hide {

      }

      div:nth-child(3) {
        height: 30px;
        width: 68px;
        background-color: #063F95;
        border-radius: 3px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }

      div:nth-child(4) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-left: 10px;
        cursor: pointer;
      }

      div:nth-child(5) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #DDDDDD;
        cursor: pointer;
      }

      div:nth-child(7) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }

      div:nth-child(6) {
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;

        .el-button--text {
          color: #333333;
        }
      }

      div:nth-child(3):hover {
        background-color: #1565dc;
      }
    }
  }

  .header-hr {
    width: 100%;
    height: 16px;
    background: #F5F5F5;
  }

  .detail-main-head {
    width: 1200px;
    padding-top: 22px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5A5A5B;
    padding-bottom: 42px;
  }

  .detail-main-tip {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    .detail-main-title {
      width: 907px;
      height: 47px;
      background: #FFFFFF;
      border: 1px solid #DDDDDD;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-right: 25px;
      display: flex;
      align-items: center;
      padding-left: 14px;
      justify-content: space-between;
      padding-right: 14px;

      div:nth-child(2) {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #F0833C;
      }
    }

    .detail-main-info {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #CCCCCC;
    }
  }

  .detail-main-step {
    width: 1000px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;

    div {
      display: flex;
      flex-flow: column;
      align-items: center;
    }

    .detail-main-step-item {
      width: 200px;
      height: 2px;
      margin-top: 20px;
      background: var(--primary);
    }

    .detail-main-step-item-no {
      width: 200px;
      height: 2px;
      margin-top: 20px;
      background: #E6E6E6;
    }

  }

  .detail-main-rx {
    width: 1200px;
    display: flex;
    align-items: center;
    margin-bottom: 31px;

    div:nth-child(1) {
      width: 5px;
      height: 18px;
      background: #999999;
    }

    div:nth-child(2) {
      width: 64px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-left: 10px;
    }
  }

  .detail-main-rx-desc {
    width: 1200px;
    display: flex;
    align-content: center;
    flex-flow: column;
    margin-bottom: 280px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 15px;

    div:nth-child(1) {
      margin-top: 31px;
    }

    div:nth-child(2) {
      margin-top: 23px;
    }
  }


  .foot {
    display: flex;
    width: 100%;
    background: white;
    height: 80px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dddddd;
    flex-flow: column;

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 28px;
    }
  }
}

.step-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;

  .step-main-head {
    width: 100%;
    height: 248px;
    background: linear-gradient(180deg, #1E3C72, #2A5298);
    display: flex;
    align-items: center;
    justify-content: center;

    .step-main-head-content {
      width: 705px;
      height: 248px;
      display: flex;

      div:nth-child(1) {
        width: 19px;
        font-size: 48px;
        font-family: FangSong;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 72px;
      }

      div:nth-child(2) {
        margin-left: 15px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 72px;
      }
    }
  }

  .step-main-content {
    margin-top: -142px;
    width: 705px;
    height: 1300px;
    background: #FFFFFF;
    display: flex;
    flex-flow: column;

    .step-main-content-title {
      margin-top: 38px;
      margin-left: 29px;
      width: 536px;
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 56px;
    }

    .step-main-content-time-cost{
      margin-left: 30px;
      margin-top: 30px;
      margin-bottom: -42px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #F0833C;
    }

    .step-main-content-step {
      margin-top: 100px;
      display: flex;
      flex-flow: column;

      .step-main-content-step-item {
        display: flex;
        margin-left: 33px;

        .step-main-content-step-item-one {
          margin-right: 33px;
          border-radius: 50%;
        }

        .step-main-content-step-item-two {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }

      .step-main-content-step-space {
        margin-left: 50px;
        width: 2px;
        height: 134px;
        background: var(--primary);
      }

      .step-main-content-step-item-status {
        display: flex;
        margin-left: 33px;

        .step-main-content-step-item-one {
          margin-right: 33px;
          border-radius: 50%;
        }

        .step-main-content-step-item-two {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }

      .step-main-content-step-space-status {
        margin-left: 47px;
        width: 2px;
        height: 134px;
        background: #F0833C;
      }

      .step-main-content-step-item-bank {
        display: flex;
        margin-left: 33px;

        .step-main-content-step-item-one {
          margin-right: 33px;
          border-radius: 50%;
        }

        .step-main-content-step-item-two {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }

      .step-main-content-step-space-bank {
        margin-left: 50px;
        width: 2px;
        height: 134px;
        background: #DDDDDD;
      }

      .step-main-content-foot {
        display: flex;
        flex-flow: column;
        margin-top: 100px;

        .step-main-content-foot-title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          display: flex;
          align-items: center;

          div:nth-child(1) {
            width: 5px;
            height: 25px;
            background: #999999;
            margin-right: 10px;
          }
        }

        .step-main-content-foot-desc {
          margin-left: 17px;
          margin-top: 30px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }
    }

  }

  .step-main-foot {
    width: 100%;
    height: 120px;
    background: #FFFFFF;
    box-shadow: 0px -2px 24px 0px rgba(116, 114, 114, 0.5);
    display: flex;
    justify-content: flex-end;

    .step-main-foot-pay {
      width: 382px;
      height: 121px;
      background: #CCCCCC;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 110px;
    }
  }
}
</style>

<style lang="less" scoped>
@media (max-width: 768px) {
  .step-main {
    width: 100%;
    min-width: 0;
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .step-main-head {
    height: 132px !important;
    align-items: flex-start !important;
  }

  .step-main-head-content {
    width: 100% !important;
    height: 76px !important;
    padding: 0 16px;
    align-items: center;
    box-sizing: border-box;
  }

  .step-main-head-content > div:first-child {
    width: auto !important;
    font-size: 30px !important;
    line-height: 1 !important;
  }

  .step-main-head-content > div:nth-child(2) {
    margin-left: 10px !important;
    font-size: 17px !important;
    line-height: 1 !important;
  }

  .step-main-content {
    width: calc(100% - 24px) !important;
    height: auto !important;
    min-height: calc(100vh - 190px);
    margin-top: -56px !important;
    padding: 22px 18px 34px;
    border-radius: 12px;
    box-sizing: border-box;
  }

  .step-main-content-title {
    width: 100% !important;
    margin: 0 !important;
    overflow-wrap: anywhere;
    font-size: 22px !important;
    line-height: 32px !important;
  }

  .step-main-content-time-cost {
    margin: 12px 0 0 !important;
    font-size: 14px !important;
  }

  .step-main-content-step {
    margin-top: 34px !important;
  }

  .step-main-content-step-item,
  .step-main-content-step-item-status,
  .step-main-content-step-item-bank {
    margin-left: 0 !important;
  }

  .step-main-content-step-item-one {
    margin-right: 14px !important;
  }

  .step-main-content-step-item-one img {
    width: 34px;
    height: 34px;
  }

  .step-main-content-step-item-two {
    min-width: 0;
    font-size: 16px !important;
  }

  .step-main-content-step-space,
  .step-main-content-step-space-status,
  .step-main-content-step-space-bank {
    height: 64px !important;
    margin-left: 16px !important;
  }

  .step-main-content-foot {
    margin-top: 42px !important;
  }

  .step-main-content-foot-title,
  .step-main-content-foot-desc {
    font-size: 15px !important;
    line-height: 24px;
  }

  .step-main-content-foot-desc {
    margin: 14px 0 0 12px !important;
  }

  .step-main-foot {
    position: sticky;
    bottom: calc(58px + env(safe-area-inset-bottom));
    height: 64px !important;
  }

  .step-main-foot-pay {
    width: 100% !important;
    height: 64px !important;
    font-size: 18px !important;
    line-height: 64px !important;
  }
}
</style>
